import api from '../components/api';

// Fetch all products
export const fetchProducts = async () => {
  const response = await api.get('/products');
  return response.data;
};

// Fetch single product
export const fetchProduct = async (productId) => {
  const response = await api.get(`/products/${productId}`);
  return response.data;
};

// Upload product with images/video
export const uploadProduct = async (productData) => {
  const formData = new FormData();
  
  // Add product JSON data
  formData.append('product', JSON.stringify({
    name: productData.name,
    description: productData.description,
    weight: productData.weight,
    purity: productData.purity,
    making: productData.making,
    quantity: productData.quantity,
    category: productData.category.toUpperCase()
  }));

  // Add required coverImage
  formData.append('coverImage', productData.coverImage);
  
  // Add optional files
  if (productData.image2) {
    formData.append('image2', productData.image2);
  }
  if (productData.image3) {
    formData.append('image3', productData.image3);
  }
  if (productData.video) {
    formData.append('video', productData.video);
  }

  const response = await api.post('/products/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Update product
export const updateProduct = async (productData ) => {
  const product_id = productData.product_id;
  const formData = new FormData();
  
  formData.append('product', JSON.stringify({
    name: productData.name,
    description: productData.description,
    weight: productData.weight,
    purity: productData.purity,
    making: productData.making,
    quantity: productData.quantity,
    category: productData.category
  }));

  // Add files if they exist
  if (productData.coverImage) {
    formData.append('coverImage', productData.coverImage);
  }
  if (productData.image2) {
    formData.append('image2', productData.image2);
  }
  if (productData.image3) {
    formData.append('image3', productData.image3);
  }
  if (productData.video) {
    formData.append('video', productData.video);
  }

  const response = await api.put(`/products/${product_id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Delete product
export const deleteProduct = async (productId) => {
  const response = await api.delete(`/products/${productId}`);
  return response.data;
};

// Filter and Sort Functions
export const applyFilters = (products, searchTerm, filters) => {
  if (!products) return [];
  
  return products.filter(product => {
    // Search term filter
    if (searchTerm && searchTerm.trim() !== '') {
      if (!product.name || !product.name.toLowerCase().includes(searchTerm.toLowerCase())) {
        return false;
      }
    }

    // Category filter
    if (filters.category && filters.category.trim() !== '') {
      if (!product.category || product.category.toUpperCase() !== filters.category.toUpperCase()) {
        return false;
      }
    }

    // Purity filter
    if (filters.purity && filters.purity.trim() !== '') {
      if (!product.purity || product.purity.toString() !== filters.purity) {
        return false;
      }
    }
    
    // Shop filter
    if (filters.wholeSalers && filters.wholeSalers.trim() !== '') {
      if (!product.registered_firm_name || product.registered_firm_name.toString() !== filters.wholeSalers) {
        return false;
      }
    }

    return true;
  }).sort((a, b) => {
    if (!filters.sort || filters.sort.trim() === '') return 0;

    const [field, order] = filters.sort.split('-');
    const multiplier = order === 'asc' ? 1 : -1;
    
    switch (field) {
      case 'name':
        return multiplier * ((a.name || '').localeCompare(b.name || ''));
      case 'price':
        return multiplier * ((a.making || 0) - (b.making || 0));
      case 'weight':
        return multiplier * ((a.weight || 0) - (b.weight || 0));
      default:
        return 0;
    }
  });
};